// Dependencies
import React, {Component} from "react";
import {Provider} from "react-redux";
import {Route, Switch} from "react-router-dom";

// Store
import {systemServerVersionsStore} from "../store/store";

// Components
import SystemServerVersionsList from "./SystemServerVersionsList/SystemServerVersionsList.component";
import Footer from "../../home/components/Footer/footer.component";

// Styles
import "./SystemServerVersionsPage.component.scss";

class SystemServerVersionsPage extends Component {
    render() {
        return (
            <Provider store={systemServerVersionsStore}>
                <div id="SystemServerVersionsPage">
                    <Switch>
                        <Route
                            path={"/admin/system-server-versions"}
                            component={SystemServerVersionsList}
                        />
                    </Switch>
                    <Footer/>
                </div>
            </Provider>
        );
    }
}

export default SystemServerVersionsPage;
